const destination1 = '/assets/cormarbus/destination/antofagasta.png';
const destination2 = '/assets/cormarbus/destination/calama.png';
const destination3 = '/assets/cormarbus/destination/coquimbo.png';
const destination4 = '/assets/cormarbus/destination/la-serena.png';
const destination5 = '/assets/cormarbus/destination/ovalle.png';
const destination6 = '/assets/cormarbus/destination/santiago.png';
const destination7 = '/assets/cormarbus/destination/sierra-gorda.png';
const destination8 = '/assets/cormarbus/destination/vicuna.png';

const gallery1 = '/assets/cormarbus/gallery/cormarbus-gallery-1.png';
const gallery2 = '/assets/cormarbus/gallery/cormarbus-gallery-2.png';
const gallery3 = '/assets/cormarbus/gallery/cormarbus-gallery-3.png';
const gallery4 = '/assets/cormarbus/gallery/cormarbus-gallery-4.png';
const gallery5 = '/assets/cormarbus/gallery/cormarbus-gallery-5.png';
const gallery6 = '/assets/cormarbus/gallery/cormarbus-gallery-6.png';
const gallery7 = '/assets/cormarbus/gallery/cormarbus-gallery-7.png';
const gallery8 = '/assets/cormarbus/gallery/cormarbus-gallery-8.png';

const destination = [
	destination1,
	destination2,
	destination3,
	destination4,
	destination5,
	destination6,
	destination7,
	destination8,
];

const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7, gallery8];

const cormarbusSlides = {
	destination,
	gallery,
};

export default cormarbusSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/cormarbusSlides.js